import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { clearPendingReferralToken, storePendingReferralToken } from '../lib/referral-attribution';
import { claimReferralLink, fetchPublicReferralLink } from '../lib/referral-links-api';

export default function ReferralLandingPage() {
  const { token = '' } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    void fetchPublicReferralLink(token)
      .then(async (link) => {
        if (cancelled) return;
        if (link.status !== 'active') {
          clearPendingReferralToken();
          navigate('/?referral_status=expired', { replace: true });
          return;
        }
        storePendingReferralToken(token, link.expiresAt);
        try {
          await claimReferralLink(token);
          clearPendingReferralToken();
        } catch {
          // An unauthenticated visitor keeps the token for the login request.
        }
        if (cancelled) return;
        navigate(link.targetPath || '/', { replace: true });
      })
      .catch(() => {
        if (cancelled) return;
        clearPendingReferralToken();
        navigate('/?referral_status=expired', { replace: true });
      });
    return () => {
      cancelled = true;
    };
  }, [navigate, token]);

  return <div className="flex min-h-screen items-center justify-center bg-stone-50 text-stone-600">正在打开推广链接...</div>;
}
